<template>
  <div v-if="inscripcionAbierta">
  <template v-if="persona && horasConActividades">
    <h4>{{ persona.nombre }} {{ persona.apellidos }} ({{ persona.nivel.nombre }})</h4>
    <h5 class="pb-2">Editar actividades desde: {{ periodo.nombre }}</h5>

    <table class="table table-bordered tabla-semana">
      <tr>
        <td class="p-0 bg-light"></td>
        <td v-for="hora in horasConActividades" :key="hora" class="align-middle p-1 px-md-2 bg-light"><b>{{ hora | rangoHoras }}</b></td>
      </tr>
      <tr v-for="dia of ['1', '2', '3', '4', '5']" :key="dia" class="fila-dia-calendario">
        <td class="align-middle text-center px-1 py-0 px-md-2 py-md-1 bg-light"><b>{{ dia | diaInicial }}</b></td>
        <td v-for="hora in horasConActividades" :key="hora" class="selector-hora p-0" :class="claseHoraSeleccionada(dia, hora)">
          <table class="table table-hover tabla-dia m-0">
            <tr v-for="a in actividadesPorHora[dia + '-' + hora]" :key="a.id_actgrupo" :class="claseActividadSeleccionada(a, dia, hora)">
              <td class="p-1 px-md-2 py-md-1" @click="alternarActividadConHora(a, dia, hora)">
                {{ a.nombre_actividad }}<template v-if="a.horas.length > 1 && ! a.seleccion_libre"> ({{ a.horas | horasSinSeleccion }})</template>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>

    <h5>Otras actividades</h5>

    <table class="table table-bordered">
      <tr v-for="a in actividadesSinHora" :key="a.id_actgrupo" :class="claseActividadSeleccionada(a, null, null)">
        <td class="p-1 px-md-2 py-md-1" @click="alternarActividadSinHora(a)">
          {{ a.nombre_actividad }} ({{ a.nombre_grupo }})
        </td>
      </tr>
    </table>

    <h5>Validación</h5>

	<p v-if="colisiones.length > 0" class="text-danger">ERROR: Hay dos actividades seleccionadas en la misma hora ({{ colisiones | mostrarHoras }})</p>
    <table class="table" v-if="colisiones.length == 0">
      <thead>
        <tr>
          <th class="p-0"></th>
          <th class="p-1">Actividad</th>
          <th class="p-1">Grupo</th>
          <th class="p-1 text-center">Cuota</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(c, index) in obtenerResumenCambios()" :key="index">
          <td v-if="c.tipo == 'igual'" class="align-middle text-center text-secondary p-0"><b>=</b></td>
          <td v-else-if="c.tipo == 'alta'" class="align-middle text-center text-success p-0">▲</td>
          <td v-else-if="c.tipo == 'baja'" class="align-middle text-center text-danger p-0">▼</td>
          <td v-else-if="c.tipo == 'modificacion'" class="align-middle text-center text-warning p-0">⇄</td>
          <td v-else></td>
          <td class="align-middle px-1 py-2 p-md-2">{{ c.actividad.nombre_actividad }}</td>
          <td class="align-middle px-1 py-2 p-md-2">
            <template v-if="c.tipo == 'baja'"></template>
            <template v-else-if="'horas' in c">{{ c.horas | mostrarHoras }}</template>
            <template v-else>{{ c.actividad.nombre_grupo }}</template>
          </td>
          <td class="align-middle px-1 py-2 p-md-2 text-center">
            <template v-if="'cuota' in c">{{ c.cuota }} €</template>
            <template v-else>consultar</template>
          </td>
        </tr>
      </tbody>
    </table>

    <button type="button" class="btn btn-primary" @click="enviarCambios()" :disabled="colisiones.length > 0">Enviar</button>

  </template>
  </div>

  <div v-else>
    <h4>Actualmente no es posible modificar las actividades</h4>
  </div>

</template>

<script>

import { api } from '../api/api.js';
import { obtenerCursoActivo, obtenerPeriodoActual, obtenerPeriodoAbierto } from '../curso.js';
import { convertirHoras } from '../utils.js';

export default {
	name: 'SociosEditarActividades',
	props: [ 'admin', 'id_persona' ],
	data () {
		return {
			persona: null,
			periodo: null,
			inscripcionAbierta: true,

			// Nota: en este módulo las referencias a "actividad" son en realidad
			// referencias a actividad+grupo, que es lo que se recibe de la API, ya que
			// son las unidades mínimas a las que se puede apuntar un alumno. Nombro
			// las variables como "actividades" por brevedad, aunque luego utilizo
			// id_actgrupo para el id, ya que es una combinación de id_actividad e id_grupo
			actividadesPorId: null,
			actividadesPorHora: null,
			actividadesSinHora: null,
			actividadesOriginales: null,
			actividadesSeleccionadas: null,
			colisiones: [],

			horasConActividades: null,
		}
	},
	created () {
		this.curso = obtenerCursoActivo();
		if (this.admin) {
			this.periodo = obtenerPeriodoActual();
		} else {
			this.periodo = obtenerPeriodoAbierto();
		}
		if (! this.periodo) {
			this.inscripcionAbierta = false;
			return;
		}
		this.obtenerPersona();
		this.obtenerParticipaciones();
		this.obtenerActividadesDisponibles();

		this.actividadesOriginales = {};
		this.actividadesSeleccionadas = {};
	},
	methods: {
		// FIXME: repetido. Extraer a librería común
		obtenerPersona() {
			api(`/personas/${this.id_persona}`)
				.then((data) => {
					this.persona = data.resultado;
				})
				.catch((error) => {
					console.log(error);
					//this.mensaje_error = error;
				});
		},
		obtenerParticipaciones() {
			api(`/personas/${this.id_persona}/actividades/${this.curso.id_curso}/${this.periodo.id_periodo}`)
				.then((data) => {
					this.procesarParticipaciones(data.resultado);
				})
				.catch((error) => {
					console.log(error);
					//this.mensaje_error = error;
				});
		},
		obtenerActividadesDisponibles() {
			api(`/actividades/${this.curso.id_curso}/disponibles/${this.periodo.id_periodo}/${this.id_persona}`)
				.then((data) => {
					this.procesarActividadesDisponibles(data.resultado);
				})
				.catch((error) => {
					console.log(error);
					//this.mensaje_error = error;
				});
		},
		procesarParticipaciones(participaciones) {
			for (const p of participaciones) {
				const id_actgrupo = `${p.id_actividad}/${p.id_grupo}`;
				this.actividadesOriginales[id_actgrupo] = {
					horas: [],
				}
				this.$set(this.actividadesSeleccionadas, id_actgrupo, {
					horas: [],
				});
				if (p.horas) {
					this.actividadesOriginales[id_actgrupo].horas = [...p.horas];
					this.actividadesSeleccionadas[id_actgrupo].horas = [...p.horas];
				}
			}
		},
		procesarActividadesDisponibles(actividadesDisponibles) {
			const horasConActividades = {};
			this.actividadesPorHora = {};
			this.actividadesSinHora = [];
			this.actividadesPorId = {};
			for (const a of actividadesDisponibles) {
				a.id_actgrupo = `${a.id_actividad}/${a.id_grupo}`;
				this.actividadesPorId[a.id_actgrupo] = a;
				if (a.horas.length == 0) {
					this.actividadesSinHora.push(a);
				} else {
					for (const diahora of a.horas) {
						if (! (diahora in this.actividadesPorHora)) {
							this.$set(this.actividadesPorHora, diahora, []);
						}
						this.actividadesPorHora[diahora].push(a);
						const horaInicio = diahora.substring(2);
						if (! (horaInicio in horasConActividades)) {
							horasConActividades[horaInicio] = true;
						}
					}
				}
			}
			this.horasConActividades = Object.keys(horasConActividades);
			this.horasConActividades.sort();
		},
		alternarActividadConHora(actividad, dia, hora) {
			if (! this.comprobarDisponibilidad(actividad)) {
				return;
			}
			if (! actividad.seleccion_libre) {
				for (const diahora of actividad.horas) {
					this.alternarActividad(actividad, diahora);
				}
			} else {
				const diahora = dia + '-' + hora;
				this.alternarActividad(actividad, diahora);
			}
			this.detectarColisiones();
		},
		alternarActividadSinHora(actividad) {
			if (! this.comprobarDisponibilidad(actividad)) {
				return;
			}
			this.alternarActividad(actividad, null);
		},
		alternarActividad(actividad, diahora) {
			if (diahora) {
				if (actividad.id_actgrupo in this.actividadesSeleccionadas) {
					const horas = this.actividadesSeleccionadas[actividad.id_actgrupo].horas;
					if (horas.includes(diahora)) {
						const index = horas.indexOf(diahora);
						horas.splice(index, 1);
						if (horas.length == 0) {
							this.$delete(this.actividadesSeleccionadas, actividad.id_actgrupo);
						}
					} else {
						horas.push(diahora);
					}
				} else {
					this.$set(this.actividadesSeleccionadas, actividad.id_actgrupo, {
						horas: [diahora],
					});
				}
			} else {
				if (actividad.id_actgrupo in this.actividadesSeleccionadas) {
					this.$delete(this.actividadesSeleccionadas, actividad.id_actgrupo);
				} else {
					this.$set(this.actividadesSeleccionadas, actividad.id_actgrupo, {});
				}
			}
		},
		comprobarDisponibilidad(actividad) {
			if (! (actividad.id_actgrupo in this.actividadesSeleccionadas) &&
				! actividad.disponible) {
				window.alert('Esta actividad no está disponible para apuntarse, probablemente for falta de plazas. Contacta con el AMPA para saber más');
				return false;
			}
			return true;
		},
		claseActividadSeleccionada(actividad, dia, hora) {
			if (dia && hora) {
				const diahora = dia + '-' + hora;
				const seleccionadas = this.obtenerSeleccionadasHora(diahora);
				if (seleccionadas.includes(actividad.id_actgrupo)) {
					if (seleccionadas.length == 1) {
						return 'table-success';
					} else {
						return 'table-danger';
					}
				}
			} else {
				if (actividad.id_actgrupo in this.actividadesSeleccionadas) {
					return 'table-success';
				}
			}
			return '';
		},
		claseHoraSeleccionada(dia, hora) {
			const diahora = dia + '-' + hora;
			const seleccionadas = this.obtenerSeleccionadasHora(diahora);
			if (seleccionadas.length > 0) {
				return 'hora-seleccionada';
			}
		},
		obtenerSeleccionadasHora(diahora) {
			const resultado = [];
			for (const [id_actgrupo, data] of Object.entries(this.actividadesSeleccionadas)) {
				if ('horas' in data && data.horas.includes(diahora)) {
					resultado.push(id_actgrupo);
				}
			}
			return resultado;
		},
		detectarColisiones() {
			const colisiones = [];
			for (const diahora of Object.keys(this.actividadesPorHora)) {
				const seleccionadas = this.obtenerSeleccionadasHora(diahora);
				if (seleccionadas.length > 1) {
					colisiones.push(diahora);
				}
			}
			this.colisiones = colisiones;
		},
		obtenerResumenCambios() {
			const cambios = [];
			for (const [id_actgrupo, actgrupo] of Object.entries(this.actividadesSeleccionadas)) {
				const actividad = this.actividadesPorId[id_actgrupo];
				const c = {
					actividad: actividad,
					tipo: 'igual',
				}
				if ('horas' in actgrupo) {
					c.horas = actgrupo.horas;
					if ('cuotas' in actividad) {
						//const index = c.horas.length.toString();
						const index = c.horas.length;
						if (index in actividad['cuotas']) {
							c.cuota = actividad['cuotas'][index];
						}
					}
				} else {
					if ('cuotas' in actividad && '0' in actividad['cuotas']) {
						c.cuota = actividad['cuotas']['0'];
					}
				}

				if (! (id_actgrupo in this.actividadesOriginales)) {
					c.tipo = 'alta';
				} else if ('horas' in this.actividadesSeleccionadas[id_actgrupo]) {
					const horasComunes = new Set(
						[...this.actividadesSeleccionadas[id_actgrupo].horas,
						...this.actividadesOriginales[id_actgrupo].horas]
					);
					if (horasComunes.size != this.actividadesSeleccionadas[id_actgrupo].horas.length ||
						horasComunes.size != this.actividadesOriginales[id_actgrupo].horas.length) {
						c.tipo = 'modificacion';
						c.horas_antes = this.actividadesOriginales[id_actgrupo].horas;
					}
				}
				cambios.push(c);
			}
			for (const id_actgrupo of Object.keys(this.actividadesOriginales)) {
				if (! (id_actgrupo in this.actividadesSeleccionadas)) {
					cambios.push({
						actividad: this.actividadesPorId[id_actgrupo],
						tipo: 'baja',
						cuota: '-',
					});
				}
			}
			return cambios;
		},
		calcularCambiosEnvio() {
			const resumenCambios = this.obtenerResumenCambios();
			const cambios = [];
			for (const c of resumenCambios) {
				if (c.tipo == 'igual') {
					continue;
				}
				cambios.push({
					tipo: c.tipo,
					id_actividad: c.actividad.id_actividad,
					id_grupo: c.actividad.id_grupo,
					horas: c.horas,
				});
			}
			return cambios;
		},
		enviarCambios() {
			const cambios = this.calcularCambiosEnvio();
			api(`/personas/${this.id_persona}/actividades/${this.curso.id_curso}/${this.periodo.id_periodo}`,
				'PUT', cambios)
				.then((data) => {
					if (data.resultado) {
						if (this.admin) {
							this.$router.push(`/admin/familia/${this.persona.id_familia}`);
						} else {
							this.$router.push('/');
						}
					}
				})
				.catch((error) => {
					console.log(error);
					//this.mensaje_error = error;
				});
		}
	},
	filters: {
		rangoHoras: function(rango) {
			return rango.substring(0, 2) + ':' + rango.substring(2, 7) + ':' + rango.substring(7, 9);
		},
		diaInicial: function(iddia) {
			let diaTxt;
			switch (iddia) {
				case '1': diaTxt = 'L'; break;
				case '2': diaTxt = 'M'; break;
				case '3': diaTxt = 'X'; break;
				case '4': diaTxt = 'J'; break;
				case '5': diaTxt = 'V'; break;
			}
			return diaTxt;
		},
        // TODO: Unificar con SociosFamilias
		mostrarHoras: function(listaHoras) {
            const convertidas = convertirHoras(listaHoras);
            return convertidas.join(', ');
			/*
			const hTxt = [];
			for (const h of listaHoras) {
				const dia = h.substring(0, 1);
				const hInicial = h.substring(2, 4) + ':' + h.substring(4, 6);
				let diaTxt;
				switch (dia) {
					case '1': diaTxt = 'L'; break;
					case '2': diaTxt = 'M'; break;
					case '3': diaTxt = 'X'; break;
					case '4': diaTxt = 'J'; break;
					case '5': diaTxt = 'V'; break;
				}
				hTxt.push(`${diaTxt} ${hInicial}`);
			}
			return hTxt.join(', ');
			*/
		},
		horasSinSeleccion: function(listaHoras) {
			const dias = [];
			for (const h of listaHoras) {
				const dia = h.substring(0, 1);
				let diaTxt;
				switch (dia) {
					case '1': diaTxt = 'L'; break;
					case '2': diaTxt = 'M'; break;
					case '3': diaTxt = 'X'; break;
					case '4': diaTxt = 'J'; break;
					case '5': diaTxt = 'V'; break;
				}
				dias.push(diaTxt);
			}
			return dias.join(', ');
		}
	}
}
</script>

<style scoped>
.tabla-semana td {
  border-width: 3px 1px;
  border-color: #c8c8c8;
}
.tabla-semana td.hora-seleccionada {
  background: #e0e0e0;
}
.tabla-dia td {
  border-width: 1px 0;
}
</style>
